import React from "react";

const LinkBankFooter = () => {
  return (
    <footer className="flex flex-col justify-center items-center text-gray-700 text-sm">
      <span>{}</span>
      <p className="mt-3">© 2023 TomoCredit</p>
    </footer>
  );
};

export default LinkBankFooter;
